import { Input } from "@Light/components/system/Input";
import { useScaffold } from "@Light/scaffold";
import { clsx } from "clsx";

export type TermsAcceptanceProps = {
  checked: boolean;
  children: React.ReactNode;
  isError?: boolean;
  onChange: (accepted: boolean) => void;
};

export const TermsAcceptance: React.FC<TermsAcceptanceProps> = ({
  checked,
  children,
  isError,
  onChange,
}) => {
  const scaffold = useScaffold();

  return (
    <label className="flex flex-row items-start gap-2">
      <Input
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
        data-testid="terms-checkbox"
        className="relative top-0.5"
        isError={isError}
      />
      <div
        className={clsx(
          "text-sm",
          isError ? "text-error-600" : scaffold.page.colors.text.tertiary,
        )}
      >
        {children}
      </div>
    </label>
  );
};
